<div>
  <h2 mat-dialog-title>Confirmación</h2>
  <div class="close-container">
    <button class="close" (click)="onCancel()">
      <i class="fa-solid fa-xmark" alt=""></i>
    </button>
  </div>
  <mat-dialog-content>{{ data.message }}</mat-dialog-content>
  <mat-dialog-actions align="end">
    <button class="button button-outlined-primary button-sm mr-2" type="button" (click)="onCancel()">Cancelar</button>
    <button class="button button-danger button-sm" type="button" (click)="onConfirm()">Eliminar</button>
  </mat-dialog-actions>
</div>
